const childRoutes = (prop) => [
    {
        path: 'registered-organization',
        name: prop + '.registered_organization',
        meta: { auth: true },
        component: () => import('../pages/registered-organization/List.vue')
    },
    {
        path: 'circular-publication',
        name: prop + '.circular_publication',
        meta: { auth: true },
        component: () => import('../pages/circular-publication/List.vue')
    },
    {
        path: 'batch-schedule',
        name: prop + '.batch_schedule',
        meta: { auth: true },
        component: () => import('../pages/batch-schedule/List.vue')
    },
    {
        path: 'applications',
        name: prop + '.applications',
        meta: { auth: true },
        component: () => import('../pages/application/List.vue')
    },
    {
        path: 'application-approval',
        name: prop + '.application_approval',
        meta: { auth: true },
        prop: true,
        component: () => import('../pages/application-approval/List.vue')
    },
    {
        path: 'make-application-approval',
        name: prop + '.application_approval_make',
        meta: { auth: true },
        prop: true,
        component: () => import('../pages/application-approval/Form.vue')
    },
    {
        path: 'batch-wise-enrollment',
        name: prop + '.batch_wise_enrollment',
        meta: { auth: true },
        prop: true,
        component: () => import('../pages/batch-wise-enrollment/List.vue')
    },
    {
        path: 'make-batch-wise-enrollment',
        name: prop + '.make_batch_wise_enrollment',
        meta: { auth: true },
        prop: true,
        component: () => import('../pages/batch-wise-enrollment/Form.vue')
    },
    {
        path: 'view-batch-wise-enrollment',
        name: prop + '.view_batch_wise_enrollment',
        meta: { auth: true },
        prop: true,
        component: () => import('../pages/batch-wise-enrollment/Details.vue')
    },
    {
        path: 'applications-sorting',
        name: prop + '.sorting_applications',
        meta: { auth: true },
        prop: true,
        component: () => import('../pages/sorting-application/List.vue')
    },
    {
        path: 'make-applications-sorting',
        name: prop + '.sorting_applications_make',
        meta: { auth: true },
        prop: true,
        component: () => import('../pages/sorting-application/Form.vue')
    },
  {
    path: 'applications-forward',
    name: prop + '.forward_applications',
    meta: { auth: true },
    prop: true,
    component: () => import('../pages/forward-application/List.vue')
  },
  {
    path: 'make-applications-forward',
    name: prop + '.forward_applications_make',
    meta: { auth: true },
    prop: true,
    component: () => import('../pages/forward-application/Form.vue')
  },
    {
        path: 'requested-document',
        name: prop + '.requested_document',
        meta: { auth: true },
        prop: true,
        component: () => import('../pages/requested-document/List.vue')
    },
    {
        path: 'complain-recommendation',
        name: prop + '.complain_recommendation',
        meta: { auth: true },
        prop: true,
        component: () => import('../pages/complain/List.vue')
    }
]

const routes = [{
    path: '/training-e-learning-service/information-application-management',
    name: 'training_e_learning_service.information_application_management',
    component: () => import('@/layouts/TrainingElearningLayout.vue'),
    meta: { auth: true },
    children: childRoutes('training_e_learning_service.information_application_management')
}]

export default routes
